import { render, staticRenderFns } from "./CouponTemplateManage.vue?vue&type=template&id=b5b659b4&lang=pug&"
import script from "./CouponTemplateManage.vue?vue&type=script&lang=ts&"
export * from "./CouponTemplateManage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports